import {
  FieldErrorsImpl,
  UseFormClearErrors,
  UseFormRegister,
  UseFormResetField,
  UseFormSetError,
  UseFormSetValue,
} from 'react-hook-form';
import { Button } from 'react-bootstrap';
import CommonImageUpload from '../../../../Components/Common/CommonImageUpload';
import Loader from '../../../../Components/Spinner/Loader';
import InputField from '../../../../Components/Common/InputField';
const StaffForm = ({
  register,
  setValue,
  clearErrors,
  resetField,
  errors,
  setError,
  loading,
  btnText,
  imageDefaultValue,
  imageRequired,
}: {
  register: UseFormRegister<any>;
  setValue?: UseFormSetValue<any>;
  clearErrors?: UseFormClearErrors<any>;
  resetField?: UseFormResetField<any>;
  errors?: Partial<FieldErrorsImpl<any>>;
  setError?: UseFormSetError<any>;
  loading?: boolean;
  imageRequired?: boolean;
  btnText?: string;
  imageDefaultValue?: string;
}) => {
  return (
    <div className='row g-3 mx'>
      <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
        <div>
          <InputField
            type='text'
            isRequired
            label='Name'
            register={register('name')}
            placeholder='Enter name'
          />
        </div>
      </div>
      <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
        <div>
          <InputField
            type='text'
            isRequired
            label='Designation'
            register={register('designation')}
            placeholder='Enter designation'
          />
        </div>
      </div>
      <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
        <div>
          <InputField
            label='Email'
            register={register('email')}
            type='email'
            placeholder='Enter email address'
          />
        </div>
      </div>{' '}
      <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
        <div>
          <InputField
            label='Phone'
            register={register('phone')}
            type='number'
            isRequired
            placeholder='Enter phone'
          />
        </div>
      </div>{' '}
      <div className='form-group col-md-6'>
        <CommonImageUpload
          register={register}
          setError={setError}
          clearErrors={clearErrors}
          setValue={setValue}
          resetField={resetField}
          errors={errors}
          label='Photo'
          fileName='photo'
          required={imageRequired}
          defaultValue={imageDefaultValue}
        />
      </div>
      <div className='form-group col-md-12 mb-3 mt-3 text-end'>
        {loading ? (
          <Loader css={'btn w-100'} />
        ) : (
          <Button type='submit' className='submit-button common-btn'>
            {btnText || ''}
          </Button>
        )}
      </div>
    </div>
  );
};

export default StaffForm;
